import AbstractRestApi from '@/api/RestApi/AbstractRestApi'

class CompanyCloudcanteens extends AbstractRestApi {
    getBaseUrl() {
        return '/api/v1/cloud-canteens'
    }
}

export default new CompanyCloudcanteens()
